import React, { Component } from 'react';
import Link from 'gatsby-link';
import Social from '../components/social';
import { siteTitle } from '../../data/config';
import styles from './index.module.scss';
import '../utils/foundation/app.scss';
import '../utils/hamburgers/hamburgers.scss';
import '../utils/fontawesome/css/font-awesome.min.css';

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = { menuOpen: false, scrolled: false };
    this.handleScroll = this.handleScroll.bind(this);
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  handleScroll() {
    const { state } = this;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (!state.scrolled && scrollTop > 0) {
      this.setState({ scrolled: true });
    } else if (state.scrolled && scrollTop === 0) {
      this.setState({ scrolled: false });
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    const { props, state } = this;
    const { data, children } = props;

    const stylesLayout = [
      styles.layout,
      state.menuOpen ? styles.layoutMenu : ''
    ].join(' ');

    return (
      <div className={stylesLayout}>
        <div className={state.scrolled ? [styles.topNav, styles.topNavScrolled].join(' ') : styles.topNav}>
          <div className={['row', 'collapse', 'align-middle', styles.topNavRow].join(' ')}>
            <div className="small-3 columns">
              <button className="hamburger" type="button" onClick={() => this.toggleMenu()}>
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </div>

            <div className="small-6 columns text-center">
              <h2 className={styles.siteTitleHeader}>
                <Link to="/" className={styles.siteTitle}>{siteTitle}</Link>
              </h2>
            </div>

            <div className="medium-3 columns show-for-medium text-right">
              <Social socialMedia={data.contentfulLayout.socialMedia} />
            </div>
          </div>
        </div>

        <div className={styles.nav}>
          <div className={styles.navWrapper}>
            <div className={styles.navContainer}>
              <button className="hamburger hamburger--boring is-active" type="button" onClick={() => this.toggleMenu()}>
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>

              <ul className={styles.navList}>
                {data.contentfulLayout.navigation.map((item, index) =>
                  <li key={index}>
                    {
                      item.url.startsWith('/')
                        ? <Link to={item.url} className={styles.navLink} onClick={() => this.closeMenu()}>{item.title}</Link>
                        : <a href={item.url} className={styles.navLink} onClick={() => this.closeMenu()}>{item.title}</a>
                    }
                  </li>
                )}
              </ul>

              <div className="show-for-small-only">
                <Social socialMedia={data.contentfulLayout.socialMedia} />
              </div>
            </div>
          </div>

          <div className={styles.navShade} onClick={() => this.closeMenu()}></div>
        </div>

        <div className={styles.main}>
          {children()}
        </div>
      </div>
    );
  }
};

export const query = graphql`
  query LayoutQuery {
    contentfulLayout {
      navigation {
        title
        url
      }
      socialMedia {
        network
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js